<div class="col-12">
  <div class="col-12">
    <!-- 帳票印刷ボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="openPrintModal">
      {{ $t('message.button_vehicle_dtc_print_modal') }}
    </b-button>
    <!-- メモボタン -->
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="parentOpenMemoModal">
      {{ $t('message.button_vehicle_dtc_note_modal') }}
    </b-button>
    <b-button v-if="testModeVisible" class="ml-2 mt-2" variant="primary" size="sm" @click="debugExport">
      Export DTC Data
    </b-button>
    <!-- 連鎖DTC表示ボタン -->
    <b-button v-if="labelSwitch" class="ml-2 mt-2" variant="primary" size="sm" @click="switchDtcChain">
      {{ $t('message.button_vehicle_dtc_chain_dtc_normal') }}
    </b-button>
    <!-- 連鎖DTC非表示ボタン -->
    <b-button v-if="!labelSwitch" class="ml-2 mt-2" variant="primary" size="sm" @click="switchDtcChain">
      {{ $t('message.button_vehicle_dtc_chain_dtc_all') }}
    </b-button>
    <b-button class="ml-2 mt-2" variant="primary" size="sm" @click="csvExport">
      {{ $t('message.file_export') }}
    </b-button>
  </div>
  <div class="col-12">
    <custom-table class="mt-2 ml-2" type="simple" useSort useStripeStyle rowSelect hasTabs currentSortkey="status"
      initSortDir="asc" :items="measuredDataItems" :columns="measuredDataColumns" @rowButtonClicked="openFFDModal">
      <template v-slot:rowButton="{ row }">
        <img v-if="row.isMultiFFD" class="ffd_icon_style" src="@/assets/img/ffd/ffd_multi.png" draggable="false" />
        <img v-else class="ffd_icon_style" src="@/assets/img/ffd/ffd_single.png" draggable="false" />
      </template>
    </custom-table>

    <!-- 帳票印刷 -->
    <b-modal v-model="modalPrintForm" header-bg-variant="secondary" header-text-variant="light" size="lg"
      no-close-on-backdrop no-close-on-esc centered no-stacking scrollable>
      <template v-slot:header>
        <div class="text-center w-100">
          {{ $t('message.header_vehicle_dtc_print_modal') }}
        </div>
      </template>

      <print-modal v-if="modalPrintForm" ref="print_modal" :userInfoProp="printUserInfo" 
        :vehicleVinProp="cachedDetails.information.vin" :vehicleVinTypeProp="cachedDetails.information.vinType" :allDtcTableProp="recollectedData" initMileage='-' />

      <template v-slot:footer>
        <div class="text-center w-100">
          <b-button size="sm" variant="outline-primary" @click="modalPrintForm=false" class="ml-2 mr-2 mt-2">
            {{ $t("message.common_button_cancel") }}
          </b-button>
          <b-button size="sm" variant="primary" @click="startPrint()" class="ml-2 mr-2 mt-2">
            {{ $t('message.button_vehicle_dtc_print') }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
  <processing-view :processing="processing"></processing-view>
</div>